import { useSelector } from "react-redux";
import { logo } from "../../asset";
import { IDCard } from "../../components";
import { Staff } from "../../types/staff";
import { RootState } from "../../store";

interface Props {
  staff?: Staff;
}

export default function IDCardContainer({ staff }:Props) {
  const school = useSelector((state: RootState) => state.access.schoolBranch);

  return (
    <div className="grid md:grid-cols-2 gap-20 print-grid">
      <IDCard
        side="front"
        logo={school?.schoolBranchIcon}
        roleLabel="Staff"
        roleGradient="linear-gradient(270deg, #FFF 0%, #E7F8F2 21.63%, #5FD0AB 40.38%, #0FA875 59.13%, #0B835C 100%)"
        textColorClass="text-success-700"
        name={staff?.fullName}
        phone={staff?.mobile}
        image={staff?.profile_image_url}
      />

      <IDCard
        side="back"
        logo={school?.schoolBranchIcon}
        roleLabel="Staff"
        textColorClass="text-success-700"
        email={staff?.email}
        address={staff?.permanentAddress}
        footerEmail={school?.emailAddress}
        QRCode={""}
        schoolName={school?.schoolBranchName}
      />
    </div>
  );
}
